import React from 'react';
import withSEO from 'Hoc/withSEO';
import Page5XXV3 from './5XXV3';

const Page500V3: React.FC = () => (
  <Page5XXV3
    title="Something went wrong"
    text="An error has occurred and our team has been notified"
  />
);

export default withSEO({ title: 'Internal Server Error' })(Page500V3);
